// extracted by mini-css-extract-plugin
export default {"page":"RenderFullPage_page__bHlnK","content":"RenderFullPage_content__J1OJk","noScrollableContent":"RenderFullPage_noScrollableContent__iFwsk"};